module.exports = __webpack_public_path__ + "media/images/lov_it2-999262f796bc15a3407a16f026abbf71.jpg";